// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"Users_tableContainer__18VXH","table":"Users_table__2sVNo","input":"Users_input__3MF2Q","selectBox":"Users_selectBox__2PXA3","form":"Users_form__3wbhS"};